import { RatingBlockTypeProps } from './TypeProps';
import { declensionFactory } from '@helpers/declension';
import { Rating } from '@app/shared';
import { MyLink } from '@ui-kit/MyLink';

import styles from './WrapperRating.module.scss';

export const WrapperRating = ({ rating, url, className }: RatingBlockTypeProps) => {
  if (!rating?.rating) {
    return null;
  }

  const reviews = declensionFactory('отзыв', 'отзыва', 'отзывов');
  const value = rating?.ratingCount + ' ' + reviews(rating?.ratingCount || 0);
  return (
    <div className={className}>
      <div className={styles.Wrapper}>
        <Rating rating={rating?.rating} />
        <div>{url ? <MyLink href={url}>{value}</MyLink> : value}</div>
      </div>
    </div>
  );
};
